import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'

const systemmanage: AppRouteModule = {
    path: '/systemmanage',
    name: 'systemmanage',
    component: LAYOUT,
    redirect: '/systemmanage',
    meta: {
        orderNo: 9,
        icon: 'ant-design:setting-outlined',
        title: '系统设置',
    },
    children: [
        {
            path: '/systemmanage/usermanage',
            name: 'usermanage',
            component: () => import('/@/views/systemmanage/usermanage/index.vue'),
            meta: {
                title: '用户管理',
            },
        },
        {
            path: '/systemmanage/rolemanage',
            name: 'rolemanage',
            component: () => import('/@/views/systemmanage/rolemanage/index.vue'),
            meta: {
                title: '角色管理',
            },
        },
        {
            path: '/systemmanage/permismanage',
            name: 'permismanage',
            component: () => import('/@/views/systemmanage/permismanage/index.vue'),
            meta: {
                title: '权限管理',
            },
        },
        {
            path: '/systemmanage/thresholdmanage',
            name: 'thresholdmanage',
            component: () => import('/@/views/systemmanage/thresholdmanage/index.vue'),
            meta: {
                title: '阈值管理',
            },
        },
        {
            path: '/systemmanage/subjectmanage',
            name: 'subjectmanage',
            component: () => import('/@/views/systemmanage/subjectmanage/index.vue'),
            meta: {
                title: '标的物管理',
            },
        },
    ],
}

export default systemmanage
